import _ from "lodash";
import { useCallback } from "react";
import FilterIcon from "../../../icons/FilterIcon";
import GridIcon from "../../../icons/GridIcon";
import ListIcon from "../../../icons/ListIcon";
import Button from "../../../toolkit/ButtonV1";
//import {Button} from "@mui/material";
import FormControl from "../../../components/FormControl";
import { useState } from "react";
import { useEffect } from "react";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { Card, Grid, Box, CardContent, Divider } from "@mui/material";

import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

//import DashboardTopContainerTitle from "../DashboardTopContainerTitle";
import "../Dashboard.css";
import DashboardTopContainerCard from "../DashboardTopContainerCard";

import Upload from "../../../icons/Upload";
import File from "../../../icons/File";
import File1 from "../../../icons/File1";
import ReportIcon from "../../../icons/ReoprtIcon";

import fileDownload from 'js-file-download'
import axios from "../../../utils/fvAxios";
import Menu from "@mui/material/Menu";
import { MenuItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { CSVLink } from "react-csv";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
//import Reports from "../../../icons/Reports";

const searchDebounceDelay = 1000;

export default function ({
    searchStr: parentSearchStr,
    setSearchStr: parentSetSearchStr,
    viewType,
    toggleViewType,
    largeScreen,
    countInfo,
    IsDownload,
    Type: val,
    CardType
}) {
    const [searchStr, setSearchStr] = useState(parentSearchStr);
    const debouncedSearchQueryHandler = useCallback(
        _.debounce(parentSetSearchStr, searchDebounceDelay),
        []
    );

    useEffect(() => {
        if (parentSearchStr !== searchStr) {
            debouncedSearchQueryHandler(searchStr);
        }
    }, [searchStr]);


    const { t } = useTranslation();
    // const [pqType, setPQType] = useState(1);
    function setVal(obj) {
        // setPQType(obj);
        val(obj);
    }

    const headers = [
        { label: "VendorName", key: "vendorName" },
        { label: "Status", key: "indicationTextClient" },
        { label: "ClientName", key: "clientName" },
        { label: "PrequalificationStart", key: "prequalificationStart" },
        { label: "PrequalificationFinish", key: "prequalificationFinish" },
        { label: "PrequalificationSubmit", key: "prequalificationSubmit" }
    ]
    function convertToCSV(data) {
        const header = headers?.map(header => `"${header.label}"`).join(',');
        const rows = data?.map(item =>
            headers?.map(header => `"${item[header.key]}"`).join(',')
        );

        return [header, ...rows].join('\n');
    }
    const [download, setDownload] = useState(null);

    const handleDownload = () => {
        axios.get(IsDownload + "&isDownload=" + true)
            .then((res) => {
                setDownload(res?.data?.data);
                if (res.data.data) {
                    const csvContent = convertToCSV(res?.data?.data);
                    const blob = new Blob([csvContent], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = CardType == 3 ? 'Client Review Prequalifications.csv' : CardType == 5 ? "Incomplete Prequalifications.csv" : 'Processing Prequalifications.csv';
                    a.click();
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                //console.error('API request failed:', error);
            })
    }




    const ITEM_HEIGHT = 50;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box>
            <Card style={{ marginBottom: "1rem", border: "none" }}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "15px",
                        "& svg": {
                            m: 1.5,
                        },
                        "& hr": {
                            mx: 0.5,
                        },
                    }}
                >
                    <h2 className="dashBoardtext">{t("Dashboard.dashboard")}</h2>

                    <Button
                        className="buttonhidden"
                        role="tertiary"
                        size="default"
                        style={{ marginRight: "10px" }}
                        href="/RecentDocuments"
                        trailingComponent={<File1 />}
                        label={t("DashboardRecentDocument.recentDocuments")}
                    />

                    <Button
                        className="buttonhidden"
                        role="tertiary"
                        size="default"
                        href="/DashboardAnalytics"
                        trailingComponent={<ReportIcon />}
                        label={t("DashboardAnalytics.dashboardAnalytics")}
                    />
                    <MoreVertIcon className="buttonhidden" onClick={handleClick} style={{ cursor: "pointer" }} />
                    <Divider
                        className="buttonhidden"
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        style={{
                            width: "2px",
                            height: "36px",
                            marginRight: "5px",
                            backgroundColor: "rgb(130 133 137)",
                        }}
                        id="menu_btn"
                    />

                    <div className="styles">
                        <FormControl
                            className="buttonhidden"
                            inputType="text"
                            placeholder="Search"
                            value={searchStr}
                            handleChange={setSearchStr}
                        />
                    </div>

                    <Card onClick={handleDownload} style={{ cursor: "pointer", width: "90px", textDecoration: "none", color: "#101828", borderStyle: "solid", borderColor: "#E4E7EC", borderRadius: "4px", marginRight: "5px", marginLeft: "10px" }}>
                        <span className="mx-1">{t("Dashboard.download")}</span>
                    </Card>


                    {largeScreen && (
                        <Button
                            className="buttonhidden"
                            role="tertiary"
                            size="default"
                            trailingComponent={
                                viewType === "list" ? <GridIcon /> : <ListIcon />
                            }
                            onClick={toggleViewType}
                        />
                    )}
                </Box>
                <Box
                    className="media"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "15px",
                        "& svg": {
                            m: 1.5,
                        },
                        "& hr": {
                            mx: 0.5,
                        },
                    }}
                >
                    <div className="styles">
                        <FormControl
                            sx={{ width: "200px", marginRight: "auto" }}
                            inputType="text"
                            placeholder="Search"
                            value={searchStr}
                            handleChange={setSearchStr}
                        />
                    </div>
                    <IconButton
                        sx={{ marginLeft: "auto", cursor: 'pointer' }}
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        id="long-menu"
                        MenuListProps={{
                            "aria-labelledby": "long-button",
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: "20ch",
                            },
                        }}
                    >
                        <MenuItem onClick={handleClose}>
                            <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/RecentDocuments">
                                {t("DashboardRecentDocument.recentDocuments")}
                            </a>
                        </MenuItem>
                        <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/DashboardAnalytics">
                            {t("DashboardAnalytics.dashboardAnalytics")}
                        </a></MenuItem>
                        <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/PowerBiReports">
                            {t("Prequalification Analytics")}
                        </a></MenuItem>
                        {/* <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} onClick={handleDownload}>
                            Download
                        </a></MenuItem> */}
                        <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/StatusDescription">
                            {t("Dashboard.statusDescription")}
                        </a></MenuItem>
                        <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/Notification">
                            {t("Dashboard.notifications")}
                        </a></MenuItem>
                        <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/adminDocument">
                            {t("Dashboard.adminDocument")}
                        </a></MenuItem>
                    </Menu>
                </Box>
                <Box style={{ padding: "16px" }} sx={{ "& h1": { m: 0 } }}>
                    <Grid
                        container
                        wrap="nowrap"
                        sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
                        spacing={2}
                        justify="flex-start"
                    >
                        <DashboardTopContainerCard
                            day={t("Dashboard.greaterthan30Days")}
                            cardclick={setVal}
                            type={1}
                            count={countInfo?.inProgressGreaterThanOneMonth}
                            isActive={CardType == 1}
                        />
                        <DashboardTopContainerCard
                            day={t("Dashboard.within30Days")}
                            cardclick={setVal}
                            type={2}
                            count={countInfo?.inProgressLessThanOneMonth}
                            isActive={CardType == 2}
                        />
                        <DashboardTopContainerCard
                            day={t("Dashboard.clientReview")}
                            cardclick={setVal}
                            type={3}
                            count={countInfo?.clientReview}
                            isActive={CardType == 3}
                        />
                        <DashboardTopContainerCard
                            day={t("Dashboard.yesterday")}
                            cardclick={setVal}
                            type={4}
                            count={countInfo?.inProgressYesterday}
                            isActive={CardType == 4}
                        />
                        <DashboardTopContainerCard
                            day={t("Dashboard.incomplete")}
                            cardclick={setVal}
                            type={5}
                            count={countInfo?.incomplete}
                            isActive={CardType == 5}
                        />
                    </Grid>
                </Box>
            </Card >
        </Box >
    );
}
